module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Checkmark_unselected_Light Blue.efc19304.svg";